import { setViewBox, setReferenceImage, fitHallIntoViewBox } from '%paysera_seat_selection_integration/js/seatings/redux';
import setWaitingHallUpdate from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actions/setWaitingHallUpdate';
import initializeHall from './initializeHall';
import initializeSeatings from './initializeSeatings';
import initializeSubscriptionsOnSale from './initializeSubscriptionsOnSale';
import initializeSectors from './initializeSectors';
import initializeHallWithSeats from './initializeHallWithSeats';

function initializeHallDefinition({
    models,
    view_box: viewBox,
    reference_image:
    referenceImage,
}, optimized) {
    return (dispatch) => {
        dispatch(setWaitingHallUpdate(true));

        if (optimized) {
            dispatch(initializeHall(models));
            dispatch(initializeSectors(models));
        } else {
            dispatch(initializeHallWithSeats(models));
        }

        dispatch(initializeSeatings());
        dispatch(initializeSubscriptionsOnSale());
        if (viewBox.coordinates !== undefined && viewBox.width !== undefined && viewBox.height !== undefined) {
            dispatch(setViewBox(viewBox));
        }
        dispatch(setReferenceImage(referenceImage));
        dispatch(fitHallIntoViewBox());
    };
}

export default initializeHallDefinition;
